import React, {Fragment, PropsWithChildren, useEffect, useRef, useState} from "react";
//import * as Modal from "components/Modal/reducers/modal";
import optionsIcon from "assets/Icon_Btn_05.png";
import classNames from "classnames";

type OptionsButtonProps = {
  config?: any,
  visibleRowOptionListener?(id:number|null): void;
  visibleOptionsMenu: number | null;
  setVisibleOptionsMenu(id: number | null): void;
  userName?: string;
  setUserName?(name: string | null): void;
  setChartType?: void;
  dashboardOptionsButton?: boolean;
};

type Props = OptionsButtonProps;


const OptionsButton: React.FC<PropsWithChildren<Props>> = ({
                                                             config,
                                                             visibleRowOptionListener,
                                                             visibleOptionsMenu,
                                                             setVisibleOptionsMenu,
                                                             userName,
                                                             setUserName,
                                                             dashboardOptionsButton,
                                                             children
                                                           }) => {
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const wrapperRef = useRef(null);

  // const [state, dispatch] = React.useReducer<typeof Modal.ModalReducer>(
  //   Modal.ModalReducer,
  //   Modal.initialState
  // );

  const classnames = classNames("TableOptions", { DashboardOptionsButton: dashboardOptionsButton })

  const handleClickOutside = (event: any, ref: any) => {
    if (ref.current) {
      if (!ref.current.contains(event.target)) {
        //setVisibleOptionsMenu(null);
        setTimeout(() => {
          setOptionsMenuOpen(false);
        }, 300);
      }
    }
  };

  useEffect(() => {
    if (!optionsMenuOpen) {
      return;
    }
    const clickOutsideListenerFunction = (e: any) => handleClickOutside(e, wrapperRef);
    document.addEventListener("click", clickOutsideListenerFunction);

    return () => {
      document.removeEventListener("click", clickOutsideListenerFunction);
    };
  }, [optionsMenuOpen]);

  const handleUserMenuClick = () => {
    if (optionsMenuOpen) {
      setVisibleOptionsMenu(null);
      setTimeout(() => {
        setOptionsMenuOpen(false);
        if (visibleRowOptionListener) {
          visibleRowOptionListener(null)
        }
      }, 300);
    } else {
      setOptionsMenuOpen(true);
      setTimeout(() => {
        setVisibleOptionsMenu(config.id);
        if (setUserName) setUserName(config.name);
        if (visibleRowOptionListener) {
          visibleRowOptionListener(config.id)
        }
      }, 10);
    }
  };

  return (
    <div ref={wrapperRef}>
      <button className={classnames} onClick={ handleUserMenuClick }><img src={ optionsIcon } alt="Options" /></button>
      <div className={ optionsMenuOpen ? (visibleOptionsMenu === config.id ? "Menu Visible" : "Menu") : "Menu Closed" }>
        { children }
      </div>
    </div>
  )
};

export default OptionsButton;
